import { fetcher } from '@commenda/utils';

const baseURL = 'marketplace/vendor/service';

type ActivateFirmProvidedServiceProps = {
  id: string;
};

type ActivateFirmProvidedServiceResponse = Response;

export async function activateFirmProvidedService({
  id,
}: ActivateFirmProvidedServiceProps): Promise<ActivateFirmProvidedServiceResponse> {
  const res = await fetcher(`${baseURL}/${id}/activate`, {
    method: 'POST',
  });

  return res;
}
